import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

const selectGameReducer = (state: RootState) => state.game;

const selectMemoryGame = createSelector(selectGameReducer, (data) => data.memoryGameStatus);
const selectAssociationGame = createSelector(selectGameReducer, (data) => data.associationGameStatus);

export { selectMemoryGame, selectAssociationGame };
